import styled, { css } from 'styled-components';
import { Ellipsis } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

interface Props {
  disabled?: boolean;
}

export const CompetitorWrapper = styled('section')<Props>`
  text-align: center;
  border-radius: ${({ theme }) => theme.x1spacePx}px;
  ${({ disabled }) => !disabled && 'cursor: pointer;'}
  flex-shrink: 0;
  width: 37%;
  margin-right: ${({ theme }) => theme.x2spacePx}px;
  ${media.smUp`
    width: 23%;
    margin-right: 6%;
  `}
  ${media.mdUp`
    width: 18%;
  `}
  ${media.lgUp`
    width: 164px;
    margin-right: ${({ theme }) => theme.x2spacePx}px;
  `}

  ${({ disabled }) =>
    !disabled &&
    css`
      &:hover {
        background-color: ${({ theme }) => theme.color.spaceGray};
      }
    `}
`;

export const CompetitorContent = styled('div')`
  padding: ${({ theme }) => theme.x2spacePx}px;
`;

interface Props {
  empty?: boolean;
}

export const CompetitorDetails = styled('div')<Props>`
  padding-top: ${({ theme }) => theme.x1spacePx}px;
  p,
  h4,
  h5 {
    margin-top: 0;
    margin-bottom: 0;
    ${Ellipsis};
  }
  p {
    ${({ theme }) => theme.typography.smallStrong}
  }
  h4,
  h5 {
    ${({ theme }) => theme.typography.xSmall}
  }
  h4 {
    text-transform: uppercase;
    border-radius: ${({ theme }) => theme.x1spacePx}px;
    background: ${({ empty, theme }) => empty && theme.color.whiteRGBA(0.1)};
  }
  h5 {
    opacity: 0.5;
  }
`;

export const SnowflakeSkeleton = styled('div')`
  position: relative;
  &:before {
    position: absolute;
    display: block;
    content: ' ';
    top: 0;
    left: 0;
    border-radius: 50%;
    width: 100%;
    padding-bottom: 100%;
    background: ${({ theme }) => theme.color.whiteRGBA(0.1)};
  }
  min-width: ${({ theme }) => theme.x6spacePx}px;
  width: 100%;

  > div {
    position: relative;
    width: 100%;
    padding-bottom: 100%;
  }
`;
